// extracted by mini-css-extract-plugin
export var active = "_cr-7";
export var container = "_cr-0";
export var evenWidth = "_cr-4";
export var large = "_cr-5";
export var outlet = "_cr-8";
export var slide = "_cr-2";
export var small = "_cr-6";
export var tab = "_cr-3";
export var tabs = "_cr-1";